export const url = new URL(window.location.href);

let uri = "";
if (url.hostname === "localhost") {
  uri = "http://groovekart.lc/modules/gkpageeditor/";
} else {
  uri =
    url.protocol + "//" + window.location.hostname + "/modules/gkpageeditor/";
}
export const ajaxUri = uri + "ajax.php";
export const imagePhp = uri + "blockImage.php?path=";
export const cdnImage = uri + "cdnImage.php?url=";
